// dependencies
import { Link } from "react-router-dom";

// contexts
import { useAuth } from "../../contexts/AuthContext.js";

// style
import "./css/profile.css";

// components
import SignOutBtn from "../../components/btns/SignOutBtn.jsx";

const Profile = () => {
    const { currentUser } = useAuth();

    return (
        <>
            {/* if logged in -> display page, else NotFound page */}
            {currentUser && (
                <div className="container">
                    <div className="page-container">
                        <div className="body-container">
                            <h1>Profile</h1>

                            <div className="logout-button">
                                <Link to="/CodeNameHaar">
                                    <SignOutBtn />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Profile;
